resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function Animation() {
  this.extends = [];
  this.node = null;
  this.id = null;
  this.initialized = false;

  // BodyMovin settings
  this.loop = true;
  this.autoplay = true;
  this.renderer = 'svg';
  this.path = null; // mutually exlusive, use bodymovin to load the json. this will be needed if images are part or the
  this.url = null;
  this.animationData = null;
  this.container = null;
  this.delay = null;
  this.preserveAspectRatio = null;

  // animation object
  this.anim = null;

  // Classes
  this._classes = {
    class: 'animation',
    container: 'animation__container',
  };

  this.init = function() {
    // Setup the Animation
    this.$node = $(this.node);
    this.$node.addClass(this._classes.class);

    this.container = $('<div></div>');
    this.container.addClass(this._classes.container);
    this.$node.append(this.container);

    this._loadAnimationLibrary();
  };

  this.initAllReady = function() {};

  this.destroy = function () {
    if (this.anim !== null) {
      this.anim.destroy();
    }

    if (this._delayedAnimation !== null) {
      clearTimeout(this._delayedAnimation);
    }
  };

  this._loadAnimationLibrary = function() {
    if (typeof bodymovin === "undefined") {
      var filePath = window.mogo.registry.mogoUI.config.resourcePaths.assetsPath + '/mogo-ui-lib-min/js/vendor/lottie.min.js?version=5.7.12';
      $.ajax({
        url: filePath,
        dataType: 'script',
        cache: true
      })
      .done(function () {
        this._loadAnimationData(this.url);
      }.bind(this));
    } else {
      this._loadAnimationData(this.url);
    }
  };

  this._loadAnimationData = function (url) {
    if (!url) {
      this._initAnimation();
      return;
    }

    $.ajax({
      url: url,
      dataType: 'json',
      cache: true
    })
    .done(function (data, response) {
      if (response === 'success') {
        this.animationData = data;
        this._initAnimation();
      } else {
        console.error('Couldn\'t load file: ' + url);
      }
    }.bind(this));
  };


  this._initAnimation = function () {
    if (this.delay) this.autoplay = false;

    // show animation
    this.anim = bodymovin.loadAnimation({
      container: this.container[0], // the dom element
      renderer: this.renderer,
      loop: this.loop,
      autoplay: this.autoplay,
      animationData: this.animationData,
      path: this.path,
      rendererSettings: {
        preserveAspectRatio: this.preserveAspectRatio
      }
    });

    this.initialized = true;

    if (this.delay) {
      this._delayedAnimation = setTimeout(function () {
        this.$node.show(this.anim.play());
      }.bind(this), parseInt(this.delay));
    } else {
      this.$node.show();
    }
  };

  // Event Callbacks
  this.onComplete = function(callback) {
    if (!this.initialized) return false;
    this.anim.addEventListener('complete', callback);
  };

  this.onLoopComplete = function(callback) {
    if (!this.initialized) return false;
    this.anim.addEventListener('loopComplete', callback);
  };

  this.onEnterFrame = function(callback) {
    if (!this.initialized) return false;
    this.anim.addEventListener('enterFrame', callback);
  };

  this.onSegmentStart = function(callback) {
    if (!this.initialized) return false;
    this.anim.addEventListener('segmentStart', callback);
  };

  this.onDataReady = function(callback) {
    if (!this.initialized) return false;
    this.anim.addEventListener('data_ready', callback);
  };


  // Animation Controls
  this.play = function() {
    if (!this.initialized) return false;
    this.anim.play();
  };


  this.stop = function() {
    if (!this.initialized) return false;
    this.anim.stop();
  };

  this.pause = function() {
    if (!this.initialized) return false;
    this.anim.pause();
  };

  // speed (1 is normal speed)
  this.setSpeed = function(speed) {
    if (!this.initialized) return false;
    this.anim.setSpeed(speed);
  };

  // first param is a numeric value. second param is a boolean that defines time or frames for first param
  this.goToAndStop = function(value, isFrame) {
    if (!this.initialized) return false;
    this.anim.goToAndStop(value, isFrame);
  };

  // first param is a numeric value. second param is a boolean that defines time or frames for first param
  this.goToAndPlay = function(value, isFrame) {
    if (!this.initialized) return false;
    this.anim.goToAndPlay(value, isFrame);
  };

  // direction (1 is normal direction.)
  this.setDirection = function(direction) {
    if (!this.initialized) return false;
    this.anim.setDirection(direction);
  };

  // first param is a single array or multiple arrays of two values each(fromFrame,toFrame), second param is a boolean for forcing the new segment right away
  this.playSegments = function(segments, forceFlag) {
    if (!this.initialized) return false;
    this.anim.playSegments(segments, forceFlag);
  };

}
